"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _gatsbyPluginGoogleAnalytics = require("gatsby-plugin-google-analytics");

var _fp = require("lodash/fp");

var _helpers = require("@walltowall/helpers");

var _core = require("./core");

var Link = function Link(_ref) {
  var to = _ref.to,
      getProps = _ref.getProps,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["to", "getProps", "children"]);
  return to && (0, _helpers.isInternal)(to) ? _react.default.createElement(_core.Text, (0, _extends2.default)({
    display: "inline",
    as: _gatsby.Link,
    to: to,
    getProps: getProps
  }, props), children) : _react.default.createElement(_core.Text, (0, _extends2.default)({
    display: "inline",
    as: _gatsbyPluginGoogleAnalytics.OutboundLink,
    href: to
  }, props), children);
};

exports.Link = Link;